// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_2y-6";
export var headerCell = "_2y-2";
export var loadingStateContent = "_2y-8";
export var rowWrapper = "_2y-4";
export var stickyAggregationCell = "_2y-b";
export var stickyAggregationRow = "_2y-7";
export var stickyColumnCell = "_2y-a";
export var stickyColumnHeaderCell = "_2y-9";
export var table = "_2y-1";
export var virtualRowWrapper = "_2y-5";
export var virtualTableBodyFiller = "_2y-d";
export var virtualTableBodyFillerBottom = "_2y-e";
export var virtualTableContainer = "_2y-0";
export var virtualTableContainerFill = "_2y-c";
export var white = "_2y-3";